class PassengerDestination {
    passengerId: number;
    destinationId: number;

    constructor(passengerId: number, destinationId: number) {
        this.passengerId = passengerId;
        this.destinationId = destinationId;
    }
}

export default PassengerDestination;
